interface Iprops {
  width: number;
  height: number;
  active: boolean;
}

export const AccountsIcon = ({ width, height, active }: Iprops) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <rect
          width={width}
          height={height}
          rx="4"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#DDEDF4"
        />
      )}
      <path
        d="M11 15.75C8.66 15.75 4 16.92 4 19.25V21H18V19.25C18 16.92 13.34 15.75 11 15.75ZM6.34 19C7.18 18.42 9.21 17.75 11 17.75C12.79 17.75 14.82 18.42 15.66 19H6.34ZM11 14C12.93 14 14.5 12.43 14.5 10.5C14.5 8.57 12.93 7 11 7C9.07 7 7.5 8.57 7.5 10.5C7.5 12.43 9.07 14 11 14ZM11 9C11.83 9 12.5 9.67 12.5 10.5C12.5 11.33 11.83 12 11 12C10.17 12 9.5 11.33 9.5 10.5C9.5 9.67 10.17 9 11 9ZM18.04 15.81C19.2 16.65 20 17.77 20 19.25V21H24V19.25C24 17.23 20.5 16.08 18.04 15.81ZM17 14C18.93 14 20.5 12.43 20.5 10.5C20.5 8.57 18.93 7 17 7C16.46 7 15.96 7.13 15.5 7.35C16.13 8.24 16.5 9.33 16.5 10.5C16.5 11.67 16.13 12.76 15.5 13.65C15.96 13.87 16.46 14 17 14Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
    </svg>
  );
};
